import React from 'react';
import { render } from 'react-dom';
import { renderToStaticMarkup } from 'react-dom/server';
import { createStore, compose } from 'redux';
import { connect } from 'react-redux';
import { install, combineReducers } from 'redux-loop';
import BrandsSearchBar from './BrandsSearchBar';
import SearchBar from 'shared-components/SearchBar';
import { reducer, Actions } from './reducer';

const onBrandSelect = (data) => {
  window.location = data.link;
};

const rootReducer = combineReducers({
  model: reducer,
  searchBarModel: SearchBar.reducer,
});

const createReduxStore = () => {
  return createStore(
    rootReducer,
    undefined,
    compose(
      install(),
      (typeof window !== 'undefined' && window.devToolsExtension) ? window.devToolsExtension() : (x) => x
    )
  );
};

const createContainer = () => {
  const connector = (s) => ({
    model: s.model.toJS(),
    searchBarModel: s.searchBarModel.toJS(),
    onBrandSelect,
  });

  return connect(connector)(BrandsSearchBar);
};

const standalone = (element) => {
  const store = createReduxStore();
  const Container = createContainer();

  store.dispatch(Actions.loadBrandsStart());

  render(
    <Container store={store} />,
    element
  );
};

const renderStaticMarkup = () => {
  const store = createReduxStore();
  const Container = createContainer();
  return renderToStaticMarkup(<Container store={store} staticRender />);
};

export default {
  reducer,
  View: BrandsSearchBar,
  standalone,
  renderStaticMarkup,
  Actions,
  rootReducer,
};



/** WEBPACK FOOTER **
 ** ./apps/homepage/components/BrandsSearchBar/index.js
 **/